import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";

import Slider from "rc-slider";
import 'rc-slider/assets/index.css';

export default observer((props) => {
  const store = useLocalObservable(() => ({some_prop: ''}));
  useEffect(() => {
    // mount
    return () => {
      // unmount
    }
  }, []);

  const renderHanlde=(node,innerProps)=>{
    node.props.style.boxShadow='none';
    return (
      <div {...node.props}>
        <div style={{textAlign:'center', color:'#ffffff', fontWeight:'bold', fontSize:12, lineHeight:'18px' }}>
          {props.renderValue?props.renderValue(innerProps.value):innerProps.value}
        </div>
      </div>
    )
  }

  return (
      <div className="rad200" style={{ paddingLeft:31, paddingRight:31,boxShadow:'inset 0px 1px 2px rgba(0, 0, 0, 0.25)',backgroundColor:'#F2F2F2', height:18, }}>
        <div className="pr">
          <div className="pa w100" style={{left:0, top:-4}}>
            <Slider
              handleStyle={{height:18, width:60, background:'#2885C9',top:9, opacity:1, borderRadius:200, border:'none', outline:'none'}}
              railStyle={{height:18, background:'none', borderRadius:200 }}
              trackStyle={{height:18, background:'none'}}
              handleRender={renderHanlde}
              min={props.min || 0} max={props.max || 100} defaultValue={0} step={props.step || 1} value={props.value} onChange={(newVal)=>{
                props.onChange(newVal);
            }} />
          </div>
        </div>
      </div>
  )

});